import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
const services = [{
  title: 'Корпоративні події',
  description: 'Гала-вечері, церемонії нагородження та масштабні святкування для лідерів ринку.',
  image: 'https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=2069&auto=format&fit=crop'
}, {
  title: 'Приватні вечірки',
  description: 'Ексклюзивні дні народження та закриті заходи з унікальною концепцією.',
  image: 'https://images.unsplash.com/photo-1566737236500-c8ac43014a67?q=80&w=2070&auto=format&fit=crop'
}, {
  title: 'Весілля',
  description: 'Режисура найважливішого дня з акцентом на естетику та індивідуальність пари.',
  image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?q=80&w=2070&auto=format&fit=crop'
}, {
  title: 'Бренд-активації',
  description: 'Презентації продуктів та PR-події, що створюють потужний медіа-резонанс.',
  image: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=2070&auto=format&fit=crop'
}];
export function Services() {
  return <section id="services" className="py-32 bg-surface relative border-b border-border" data-id="element-138">
      <div className="container mx-auto px-6 md:px-12" data-id="element-139">
        <div className="flex flex-col md:flex-row justify-between items-end mb-20 md:mb-32" data-id="element-140">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} data-id="element-141">
            <h2 className="text-secondary uppercase tracking-super-wide text-[10px] font-sans mb-6" data-id="element-142">
              Експертиза
            </h2>
            <h3 className="text-5xl md:text-7xl font-serif text-primary" data-id="element-143">
              Наші Послуги
            </h3>
          </motion.div>

          <motion.p className="text-secondary font-sans max-w-sm mt-8 md:mt-0 text-sm font-light leading-relaxed" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.2
        }} data-id="element-144">
            Кожен формат вимагає свого підходу, але незмінним залишається наш
            рівень виконання — бездоганний.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-24" data-id="element-145">
          {services.map((service, index) => <motion.div key={index} className="group relative cursor-none" initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 1,
          delay: index * 0.1
        }} data-id="element-146">
              <div className="overflow-hidden relative aspect-[4/5] mb-8 bg-surface-light" data-id="element-147">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover grayscale opacity-70 transform group-hover:scale-105 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-1000 ease-[cubic-bezier(0.25,1,0.5,1)]" data-id="element-148" />
              </div>
              <div className="flex justify-between items-start border-t border-border pt-6" data-id="element-149">
                <div data-id="element-150">
                  <h4 className="text-2xl md:text-3xl font-serif mb-4 text-primary transition-colors duration-500" data-id="element-151">
                    {service.title}
                  </h4>
                  <p className="text-secondary font-sans text-sm font-light max-w-sm leading-relaxed" data-id="element-152">
                    {service.description}
                  </p>
                </div>
                <div className="w-12 h-12 rounded-full border border-border flex items-center justify-center group-hover:bg-primary group-hover:text-background transition-all duration-500" data-id="element-153">
                  <ArrowUpRight size={20} strokeWidth={1} data-id="element-154" />
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}